import { useTranslation } from "react-i18next";
import type { Notification } from "../../../../../store/admin/notificationsStore";
import { DENSE_LIST, type ThemeClasses } from "../../../shared";
import NotificationRow from "./NotificationRow";

interface NotificationsTableProps {
  themeClasses: ThemeClasses;
  notifications: Notification[];
  loading: boolean;
  error: string | null;
  onViewNotification: (notification: Notification) => void;
  onEditNotification: (notification: Notification) => void;
}

export default function NotificationsTable({
  themeClasses,
  notifications,
  loading,
  error,
  onViewNotification,
  onEditNotification,
}: NotificationsTableProps) {
  const { t } = useTranslation("adminSections");

  if (loading) {
    return (
      <div className="flex justify-center items-center py-16">
        <div className="flex flex-col items-center">
          <i className="ri-loader-4-line animate-spin text-3xl text-primary-500 mb-3"></i>
          <p className="text-gray-500">{t("notifications.loading")}</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center py-16">
        <div className="flex flex-col items-center">
          <i className="ri-error-warning-line text-3xl text-red-500 mb-3"></i>
          <p className="text-red-500">{error}</p>
        </div>
      </div>
    );
  }

  if (notifications.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16">
        <i
          className={`ri-notification-off-line text-5xl ${themeClasses.textSecondary} mb-4`}
        ></i>
        <h3 className={`text-lg font-medium ${themeClasses.text} mb-2`}>
          {t("notifications.noNotifications")}
        </h3>
        <p className={`${themeClasses.textSecondary} text-sm`}>
          {t("notifications.noNotificationsDescription")}
        </p>
      </div>
    );
  }

  return (
    <div className={DENSE_LIST}>
      {notifications.map((notification) => (
        <NotificationRow
          key={notification.id}
          notification={notification}
          themeClasses={themeClasses}
          onView={() => onViewNotification(notification)}
          onEdit={() => onEditNotification(notification)}
        />
      ))}
    </div>
  );
}
